<template>
  <HiDialog
    v-model="isOpen"
    @submit="submit"
    submit-txt="Merge"
    :submit-disabled="disabled"
    title="Duplicated Emails"
    :width="leadsData.length * 500"
    :error="error"
  >
    <div class="pt-8 flex-row">
      <div
        v-for="lead in leadsData"
        :key="lead.id"
        style="flex-grow:1;height:100%;position:relative"
      >
        <div
          style="position:fixed;background-color: #474643;z-index: 1;transform: translateY(-100%);border-radius: 3px"
        >
          <hi-clickable
            @click="setMain(lead.id)"
            shade
            pa
            :disabled="mainLead === lead.id"
            >Set As Main</hi-clickable
          >

          <hi-clickable shade pa @click="del(lead.id)">Delete</hi-clickable>
        </div>
        <div
          v-html="renderLead(lead)"
          class="px-2"
          :class="{ 'main-lead': isMain(lead.id) }"
        ></div>
      </div>
    </div>
  </HiDialog>
</template>

<script>
import HiDialog from "@/components/HiDialog";
import { db, docById } from "@/db";
import Hivue from "@/hive/Hivue";
import Formatter from "@/hive/Formatter";
import HiClickable from "@/components/HiClickable";
import hive from "@/hive";

export default {
  name: "DuplicatedEmails",
  components: {
    HiClickable,
    HiDialog
  },
  props: {
    // leads: {
    //   type: Array,
    //   required: true
    // }
  },
  data() {
    return {
      leadsData: [],
      mainLead: null,
      isOpen: false,
      error: null
    };
  },
  methods: {
    async open(leads) {
      this.isOpen = true;
      this.leadsData = [];
      for (let i = 0; i < leads.length; i++) {
        const doc = await db.doc("leads/" + leads[i]).get();
        const data = doc.data();
        data.id = doc.id;
        this.leadsData.push(data);
      }
    },
    async submit() {
      try {
        const leads = [this.mainLead];
        for (let i = 0; i < this.leadsData.length; i++) {
          const lead = this.leadsData[i];
          if (lead.id !== this.mainLead) {
            leads.push(lead.id);
          }
        }
        /*TODO cal merge here
          submit leadsMerge(leads). the first one in the array is the main lead.
         */

        console.log(leads);
        this.isOpen = false;
      } catch (e) {
        this.error = e;
      }
    },
    setMain(id) {
      this.mainLead = id;
    },
    isMain(id) {
      // console.log(id + " " + this.mainLead);
      return this.mainLead === id;
    },
    renderLead(data) {
      return Hivue.printObject(data, true, v => {
        if (v.nanoseconds) {
          return Formatter.timestamp(v, true);
        }
        return v;
      });
    },
    async del(id) {
      const yes = await hive.confirm(
        `Are you sure you want to delete lead ("${id}")?`
      );
      if (yes) {
        try {
          await docById.lead(id).delete();
          hive.toastSuccess(`Lead (${{ id }}) has been deleted.`);
          for (let i = 0; i < this.leadsData.length; i++) {
            const lead = this.leadsData[i];
            if (lead.id === id) {
              this.leadsData.splice(i, 1);
              break;
            }
          }
        } catch (e) {
          hive.toastError(e.message);
        }
      }
    }
  },
  computed: {
    disabled() {
      if (this.leadsData.length && this.mainLead) return false;
      return true;
    }
  }
};
</script>

<style scoped>
.main-lead {
  background-color: rgba(255, 255, 255, 0.7);
}
</style>
